import { render } from "./PopoverTooltipsPage.vue?vue&type=template&id=01be793c&ts=true"
import script from "./PopoverTooltipsPage.vue?vue&type=script&lang=ts"
export * from "./PopoverTooltipsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__